/** Vendor */
import { combineReducers } from "redux";
import { createAction, createReducer } from "@reduxjs/toolkit";

/** Custom Actions */
import * as types from "../actions/types";
import initialState from "./initialState";
import redux from "../../dist/js/redux";

/** Enums */
import { ResourceId } from "types";
import store from "@redux/configureStore";
import { getConectedBankAction } from "@redux/actions/banks";

const link_token = createReducer(initialState.banks.link_token, (builder) => {
  builder
    .addCase(createAction(types.GET_BANK_LINK_TOKEN), (state, action) => {
      return action.link_token;
    })
    .addDefaultCase((state) => state);
});

const accounts = createReducer(initialState.banks.accounts, (builder) => {
  builder
    .addCase(createAction(types.GET_CONNECTED_BANK_SUCCESS), (state, action) => {
      return action.accounts;
    })
    .addCase(createAction(types.ADD_BANK_SUCCESS), (state, action) => {
      return action.accounts.accounts;
      // const resource_name = action?.user?.resource_name;
      // if (resource_name) {
      //   store.dispatch(getConectedBankAction(resource_name));
      // }
    })
    .addCase(createAction(types.ATTACH_BANK_TO_PROPERTY), (state, action) => {
      return action.accounts;
    })
    .addCase(createAction(types.DELETE_PLAID_ITEM_SUCCESS), (state, action) => {
      return action.accounts;
    })
    .addCase(createAction(types.DETACH_BANK_FROM_PROPERTY_SUCCESS), (state, action) => {
      return action.accounts;
    })
    .addCase(createAction(types.RENAME_BANK_ACCOUNT_SUCCESS), (state, action) => {

      return action.accounts;
    })
    .addDefaultCase((state) => state);
});

const transactions = createReducer(initialState.banks.transactions, (builder) => {
  builder
    .addCase(createAction(types.GET_BANK_TRANSACTIONS_SUCCESS), (state, action) => {
      // Store both the transactions array and the lastKey
      // const transactionsState = {
      //   transactions: action.results || [],
      //   lastKey: action.lastKey || null
      // };
      // return transactionsState;
      return {
        ...state,
        transactions: [...(state?.transactions) || [], ...(action.results || [])],
        lastKey: action.lastKey || null
      };
    })
    .addCase(createAction(types.GET_BANK_FILTER_TRANSACTIONS_SUCCESS), (state, action) => {
      const transactionsState = {
        transactions: action.results || [],
        lastKey: action.lastKey || null
      };
      return transactionsState;
    })
    .addCase(createAction(types.FETCH_TRANSACTIONS_SUCCESS), (state, action) => {
      // Keep existing implementation or update as needed
      return state;
    })
    .addCase(createAction(types.UPDATE_TRANSACTION_CATEGORY_SUCCESS), (state, action) => {
      // Update the transactions array while preserving the lastKey
      return {
        ...state,
        transactions: state.transactions?.map((txn) =>
          txn.resource_name === action.resource_name
            ? { ...txn, internal_category: action.internal_category }
            : txn
        ) || []
      };
    })
    .addCase(createAction(types.LINK_TRANSACTION_PROPERTY_SUCCESS), (state, action) => {
      // Update the transactions array while preserving the lastKey
      return {
        ...state,
        transactions: state.transactions?.map((txn) =>
          txn.resource_name === action.resource_name
            ? { ...txn, property_name: action.property_name }
            : txn
        ) || [],
        duplicationStatus: null,
        duplicationMessage: null,
        duplicatesRecords: null,
        propertyName: null
      };
    })
    .addCase(createAction(types.UPDATE_TRANSACTION_NOTES_SUCCESS), (state, action) => {
      // Update the transactions array while preserving the lastKey
      return {
        ...state,
        transactions: state.transactions?.map((txn) =>
          txn.resource_name === action.resource_name
            ? { ...txn, notes: action.notes }
            : txn
        ) || [],
      };
    })
    .addCase(createAction(types.CHECK_DUPLICATION), (state, action) => {
      return {
        ...state,
        duplicationStatus: action.status
      };
    })
    .addCase(createAction(types.CHECK_MULTIPLE_DUPLICATION), (state, action) => {
      return {
        ...state,
        duplicationStatus: false
      };
    })
    .addCase(createAction(types.DUPLICATE_TRANSACTION_WARNING), (state, action) => {
      return {
        ...state,
        duplicationStatus: action.status,
        duplicationMessage: action.message,
        duplicatesRecords: action.duplicatesRecords,
        propertyName: action.propertyName
      };
    })
    .addCase(createAction(types.DUPLICATE_MULTIPLE_TRANSACTION_WARNING), (state, action) => {
      return {
        ...state,
        duplicationStatus: true,
        duplicatesRecordsForMultipleTransactons: action.results,
      };
    })
    .addCase(createAction(types.LINK_TRANSACTION_PROPERTY_CANCEL), (state, action) => {
      return {
        ...state,
        duplicationStatus: null,
        duplicationMessage: null,
        duplicatesRecords: null,
        propertyName: null,
        duplicatesRecordsForMultipleTransactons: null
      };
    })
    .addCase(createAction(types.SET_HAS_FETCHED_ALL_TRANSACTIONS), (state, action) => {
      console.log(" SET_HAS_FETCHED_ALL_TRANSACTIONS:", action.payload)
      return {
        ...state,
        hasFetchedAllTransactions: action.payload,
      };
    })
    .addDefaultCase((state) => state);
});

const banks = combineReducers({ link_token, accounts, transactions });

export default banks;
